export const Product_OS_Data = {
    "top-down-bottom-up": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Top-Down Bottom-Up | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/top-down-bottom-up/',

        Product_OS_TITLE: "Colby Top-Down Bottom-Up",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/watjP8y3TE8?si=wZSzU24vCLVgf0Dk",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "Callistus Colby Blind Top-Down/Bottom-Up system offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light."
    },
    "colby-blinds-day-and-night": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds Day and Night | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/colby-blinds-day-and-night/',

        Product_OS_TITLE: "Colby Blinds Day and Night",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/VpSuMSQaNuI?si=CjMdYWT6mtj9Lq7T",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION:
            <>
                Day & Night system offers maximum light control by using two separate fabrics to achieve a day / night level of convenience, providing limitless options for privacy and light control. Day & Night system is available in the following combination options : <br />
                1) Sheer – Translucent <br />
                2) Sheer – Blackout <br />
                3) Translucent – Blackout
            </>
    },
    "colby-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/colby-blinds-remote-control/',

        Product_OS_TITLE: "Colby Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/C7OT4uO6diA?si=hmzJtoEeO8sRQMTt",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colours and can also be affixed to a wall."
    },
    "sierra-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Sierra Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/sierra-blinds-manual/',

        Product_OS_TITLE: "Sierra Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/nRR1NisUTqQ?si=7nlE_NpEaK38CY8A",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "grayson-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/grayson-blinds-manual/',

        Product_OS_TITLE: "Grayson Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/_NffkTjubZs?si=a3n11IC4Zgt2Atov",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "grayson-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/grayson-blinds-remote-control/',

        Product_OS_TITLE: "Grayson Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/9d0T-N0CC5M?si=QtV6OYBab_-sEZ6E",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "roller-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/roller-blinds-manual/',

        Product_OS_TITLE: "Roller Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/u18lwoP7u50?si=d0TdPAAMMeJamjO7",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "roller-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/roller-remote-control/',

        Product_OS_TITLE: "Roller Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/z-Tvom9T33Y?si=vaGYjeAVtUN6QtIp",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "roller-blinds-one-touch-up": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds One Touch Up | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/roller-blinds-one-touch-up/',

        Product_OS_TITLE: "Roller Blinds One Touch Up",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/eMponETwg2w?si=54MdMhrAkhKOz_9e",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own."
    },
    "wooden-venetian-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/wooden-venetian-blinds-manual/',

        Product_OS_TITLE: "Wooden Venetian Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/nloVJy8-I7E?si=77sYYX8SB1Sx6J0A",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "wooden-venetian-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/wooden-venetian-blinds-remote-control/',

        Product_OS_TITLE: "Wooden Venetian Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/-vgpTkajZqY?si=YAVBaBlhHRSP6VVO",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "luzon-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Luzon Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/luzon-blinds-manual/',

        Product_OS_TITLE: "Luzon Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/M53uTNZn-Fg?si=xDaLstxdOVjiUj-l",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "luzon-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Luzon Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/luzon-blinds-remote-control/',

        Product_OS_TITLE: "Luzon Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/Jn1J0jidytY?si=z0uNNJNcw6zsTk-Z",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "skylight-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Skylight Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/skylight-blinds-remote-control/',

        Product_OS_TITLE: "Skylight Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/aD4D4lUvm9M?si=_J_LWueRXVNZx7q_",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate blinds with just a press of a button."
    },
    "panel-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Panel Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/panel-blinds-remote-control/',

        Product_OS_TITLE: "Panel Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/41sPgv-juwg?si=z53T0yVQ0jsQw3qO",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate window blinds with just a press of a button."
    },
    "panel-blinds-cord-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Panel Blinds Cord Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/panel-blinds-cord-control/',

        Product_OS_TITLE: "Panel Blinds Cord Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/FI06QrDsp3o?si=zENNQ2QOkJsbZU5N",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Blinds is their ease of operation. A continuous cord is used to open and close the blinds without any hassles."
    },
    "roman-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roman Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/roman-blinds-manual/',

        Product_OS_TITLE: "Roman Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/4tF2AsgeIcE?si=-GMFv5cf296BSuC4",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "roman-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roman Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/roman-blinds-remote-control/',

        Product_OS_TITLE: "Roman Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/e1Rz3n0drQk?si=u9TnhBG_lM5WskVy",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to wall."
    },
    "aric-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Aric Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/aric-blinds-manual/',

        Product_OS_TITLE: "Aric Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/F5kIDD8NBkA?si=InRTAtQvWxgmeX10",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "patricia-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/patricia-blinds-manual/',

        Product_OS_TITLE: "Patricia Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/6zQmiAr7-9Y?si=A3WDEJOp-Ed_JF9j",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "patricia-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/patricia-blinds-remote-control/',

        Product_OS_TITLE: "Patricia Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/PnCvR2s1OiA?si=jzdLU6a49ZlXKS5T",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "dorren-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Dorren Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/dorren-blinds-manual/',

        Product_OS_TITLE: "Dorren Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/OVHOsyyHvMQ?si=Miiw5e4Q-6GU7aV8",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
    "meliso-blinds-remote-control": {

        // Page Meta Fields
        META_PG_OG_Title: 'Meliso Blinds Remote Control | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/meliso-blinds-remote-control/',

        Product_OS_TITLE: "Meliso Blinds Remote Control",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/Vt-hIM4htEU?si=k34O9ZyX1A860b5q",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall."
    },
    "eton-blinds-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Eton Blinds Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/eton-blinds-manual/',

        Product_OS_TITLE: "Eton Blinds Manual",
        Product_OS_VID_Embed_Link: "https://www.youtube.com/embed/2epfflEQL7w?si=1sDOKIf8_dwJjTPM",
        Product_OS_Sub_TITLE: "Features a Retractable Cord",
        Product_OS_DECRIPTION: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind."
    },
}